const NON_DIGIT_DOT = /[^\d.]/g;

// Strip redundant leading zeros from a whole integer
// "007" -> "7", "000" -> "0".
function stripRedundantLeadingZeros(integerDigits: string): string {
  if (!integerDigits) return '';
  const trimmed = integerDigits.replace(/^0+(?=\d)/, '');
  return trimmed === '' ? '0' : trimmed;
}

// Parse the visible input value to the stored value
export function parseCurrencyToStored(raw: string): string {
  let filtered = raw.replace(NON_DIGIT_DOT, '');
  if (!filtered) return '';

  // Add leading zero if string starts with '.'
  if (filtered.startsWith('.')) {
    filtered = `0${filtered}`;
  }

  const dotIdx = filtered.indexOf('.');
  const hasDot = dotIdx !== -1;

  if (!hasDot) {
    return stripRedundantLeadingZeros(filtered);
  }

  const wholeRaw = filtered.slice(0, dotIdx);
  // Remove extra periods that come after the first
  const fracRaw = filtered.slice(dotIdx + 1).replace(/\./g, '');
  // Remove more than 2 decimal places
  const fracLimited = fracRaw.slice(0, 2);
  const trailingDotOnly = fracRaw === '' && filtered.endsWith('.');

  const whole = stripRedundantLeadingZeros(wholeRaw);

  if (trailingDotOnly) {
    return `${whole}.`;
  }

  return `${whole}.${fracLimited}`;
}

// Format stored value for input display
export function formatCurrencyDisplay(stored: string): string {
  if (stored === '') return '';
  return `$${stored}`;
}
